module.exports = __webpack_public_path__ + "media/images/bundle-lite-0dcea2cd32a04d521e6ed21b23d02612.png";